import { Component, PropSync, Vue } from "vue-property-decorator";

@Component<UserTitle>({
  components: {}
})
export default class UserTitle extends Vue {
  @PropSync("title", { type: String })
  syncedTitle!: string;
  @PropSync("addContent", { type: String })
  syncedAddContent!: string;
  @PropSync("addURI", { type: String })
  syncedAddURI!: string;

  private exportFile() {
    this.$emit("exportFile");
  }
}
